<div class="u-display-none loader-indicator">
  <div class="loader-indicator__wrapper" (click)="hideLoading()">
    <mat-spinner></mat-spinner>
  </div>
</div>
